module.exports = __webpack_public_path__ + "img/react.0b1fee7d.jpg";